import Service from "../Service";

const resource = "UserAssignment/";

export default {
  list(managerUsrID, requestID) {
    return Service.post(resource + "list", null, {
      params: { managerUsrID: managerUsrID, requestID: requestID },
    });
  },
  save(payload, requestID) {
    return Service.post(resource + "save", payload, {
      params: { requestID: requestID },
    });
  },
};